// extracted by mini-css-extract-plugin
module.exports = {"enter":"AnimatedSwitch_enter__2mH6M","enterActive":"AnimatedSwitch_enterActive__1VvjW","exit":"AnimatedSwitch_exit__1pISa","exitActive":"AnimatedSwitch_exitActive__aItB0"};